import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const adminHeaders = () => ({ "X-Admin-Pin": sessionStorage.getItem("admin_pin") || "" });

export const fmt = (v, d = 1) => (v == null ? "—" : Number(v).toFixed(d));

export const api = {
  settings: () => axios.get(`${API}/settings`).then((r) => r.data),
  saveSettings: (s) => axios.put(`${API}/settings`, s, { headers: adminHeaders() }).then((r) => r.data),
  verify: (pin) => axios.post(`${API}/admin/verify`, {}, { headers: { "X-Admin-Pin": pin } }),
  saveTest: (t) => axios.post(`${API}/tests`, t).then((r) => r.data),
  myTests: (rep_name) => axios.get(`${API}/tests/mine`, { params: { rep_name } }).then((r) => r.data),
  tests: () => axios.get(`${API}/tests`, { headers: adminHeaders() }).then((r) => r.data),
  deleteTest: (id) => axios.delete(`${API}/tests/${id}`, { headers: adminHeaders() }),
  clearTests: () => axios.delete(`${API}/tests`, { headers: adminHeaders(), params: { confirm: "DELETE" } }).then((r) => r.data),
  rewardSettings: () => axios.get(`${API}/reward-settings`).then((r) => r.data),
  saveRewardSettings: (b) => axios.put(`${API}/reward-settings`, b, { headers: adminHeaders() }).then((r) => r.data),
  wallet: (phone) => axios.get(`${API}/rewards/${phone}`).then((r) => r.data),
  redeem: (phone, mb, megatel_number) => axios.post(`${API}/rewards/${phone}/redeem`, { mb, megatel_number, terms_accepted: true }).then((r) => r.data),
  redemptions: () => axios.get(`${API}/admin/redemptions`, { headers: adminHeaders() }).then((r) => r.data),
  markRedemption: (id, status) => axios.post(`${API}/admin/redemptions/${id}`, { status }, { headers: adminHeaders() }),
  wallets: () => axios.get(`${API}/admin/wallets`, { headers: adminHeaders() }).then((r) => r.data),
  exportRewards: () => axios.get(`${API}/admin/rewards/export`, { headers: adminHeaders(), responseType: "blob" }).then((r) => r.data),
};
